import { render, staticRenderFns } from "./EntityCard.vue?vue&type=template&id=a2a55b56&scoped=true&"
import script from "./EntityCard.vue?vue&type=script&lang=js&"
export * from "./EntityCard.vue?vue&type=script&lang=js&"
import style0 from "./EntityCard.vue?vue&type=style&index=0&id=a2a55b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a55b56",
  null
  
)

export default component.exports